export default function Footer() {
  const year = new Date().getFullYear();

  const countryLinks = [
    { code: 'US', name: 'USA' }, { code: 'UK', name: 'UK' }, { code: 'IN', name: 'India' },
    { code: 'CA', name: 'Canada' }, { code: 'AU', name: 'Australia' }, { code: 'DE', name: 'Germany' },
    { code: 'FR', name: 'France' }, { code: 'SG', name: 'Singapore' }, { code: 'AE', name: 'UAE' },
    { code: 'JP', name: 'Japan' }, { code: 'NL', name: 'Netherlands' }, { code: 'SE', name: 'Sweden' }
  ];

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__top">
          <div className="footer__brand">
            <span className="footer__logo">◈ SalaryLens</span>
            <p className="footer__tagline">
              The world&apos;s most accurate salary & tax calculator. Free, instant, and trusted by professionals in 12+ countries.
            </p>
            <p className="footer__disclaimer">
              ⚠ <strong>Disclaimer:</strong> Results are for informational purposes only and do not constitute financial, tax, or legal advice. Tax laws change frequently. Always verify with a qualified tax professional or your national tax authority.
            </p>
          </div>

          <div className="footer__cols">
            <div className="footer__col">
              <h4 className="footer__col-title">Calculators by Country</h4>
              <ul className="footer__links">
                {countryLinks.map(({ code, name }) => (
                  <li key={code}>
                    <a href={`https://salarycalculatorapp.com/?country=${code}`} className="footer__link">
                      {name} Salary Calculator
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer__col">
              <h4 className="footer__col-title">Resources</h4>
              <ul className="footer__links">
                <li><a href="https://salarycalculatorapp.com/about" className="footer__link">About SalaryLens</a></li>
                <li><a href="https://salarycalculatorapp.com/privacy" className="footer__link">Privacy Policy</a></li>
                <li><a href="https://salarycalculatorapp.com/terms" className="footer__link">Terms of Service</a></li>
                <li><a href="https://salarycalculatorapp.com/disclaimer" className="footer__link">Disclaimer</a></li>
                <li><a href="https://salarycalculatorapp.com/contact" className="footer__link">Contact Us</a></li>
                <li><a href="https://salarycalculatorapp.com/sitemap.xml" className="footer__link">Sitemap</a></li>
              </ul>
            </div>

            <div className="footer__col">
              <h4 className="footer__col-title">Popular Queries</h4>
              <ul className="footer__links">
                <li><a href="https://salarycalculatorapp.com/?country=US&salary=100000&period=annual" className="footer__link">$100K US Salary After Tax</a></li>
                <li><a href="https://salarycalculatorapp.com/?country=UK&salary=50000&period=annual" className="footer__link">£50K UK Take-Home Pay</a></li>
                <li><a href="https://salarycalculatorapp.com/?country=IN&salary=1500000&period=annual" className="footer__link">₹15L India Net Salary</a></li>
                <li><a href="https://salarycalculatorapp.com/?country=CA&salary=80000&period=annual" className="footer__link">CA$80K Canada Net Pay</a></li>
                <li><a href="https://salarycalculatorapp.com/?country=AU&salary=100000&period=annual" className="footer__link">A$100K Australia After Tax</a></li>
                <li><a href="https://salarycalculatorapp.com/?country=DE&salary=60000&period=annual" className="footer__link">€60K Germany Net Salary</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">
            © {year} SalaryLens — <a href="https://salarycalculatorapp.com/" className="footer__link">salarycalculatorapp.com</a>. All rights reserved.
          </p>
          <p className="footer__legal">
            Tax rates are based on publicly available information for the {year - 1}/{year} tax year. SalaryLens is not affiliated with any government tax authority. Use this tool as a starting point for financial planning only.
          </p>
        </div>
      </div>
    </footer>
  );
}